import type { RouteObject } from 'react-router-dom';
import { mainPageRoutes } from './mainPageRoutes';
import AuthCallbackPage from '../pages/AuthCallback';
import React from 'react';
import { MainPage } from '../pages/Main';
import RenewCallbackPage from '../pages/RenewCallback';

export const routes: RouteObject[] = [
  {
    path: '/auth/callback/keycloak',
    element: <AuthCallbackPage />,
  },
  {
    path: '/auth/callback/keycloak-silent',
    element: <RenewCallbackPage />,
  },
  {
    path: '/',
    element: <MainPage />,
    children: [mainPageRoutes],
  },
];
